'use client';

import { filterBlank } from '@dte/otw-utils-core/src/lists/filterEmpty';
import { getArray } from '@dte/otw-utils-core/src/lists/mergeArrays';
import { uniqueValues } from '@dte/otw-utils-core/src/lists/uniqueValues';
import { isEmptyArray } from '@dte/otw-utils-core/src/objects/isEmpty';
import { normalizeValues } from '@dte/otw-utils-core/src/strings/normalizeValues';

export function joinClasses(...classes: string[]): string | undefined {
	let classNames = getArray(classes);

	// Seprate the classes by spaces
	classNames = classNames.join(' ').split(' ');

	// Make sure we have only unique values
	classNames = normalizeValues(classNames);
	classNames = uniqueValues(classNames);

	const filtered = filterBlank(classNames);
	if (isEmptyArray(filtered)) {
		return undefined;
	}
	return filtered.join(' ');
}

export function addClassName(existingClassName: string, className: string): string | undefined {
	return joinClasses(existingClassName, className);
}
